import { useState, useEffect } from 'react'
import { IMedia } from 'src/utils/Interfaces/media.interface'
import style from './style.module.scss'
import { getFilesSize } from 'src/utils/services/fileSize'
import dateFormat from 'src/utils/services/dateFormat'

export const MediaItem = ({ item }: { item: IMedia }) => {
  const [fileSize, setFileSize] = useState('')

  useEffect(() => {
    getFilesSize(item.url).then((size) => {
      if (size) {
        setFileSize(size?.kilobytes)
      }
    })
  }, [item])

  const copyClickHandler = () => {
    navigator.clipboard.writeText(item.url)
  }

  return (
    <li className={style.media_item}>
      <span className={style.thumbnail}>
        <img src={item.url} alt={item.name} />
      </span>
      <span className={style.name}>{item.type}</span>
      <span className={style.extension}>{item.url.split('.').pop()}</span>
      <span className={style.size}>{fileSize} KB</span>
      <span>{dateFormat(item.createdAt)}</span>
      <span>
        <button title="Copy url" className={style.copy_url} onClick={copyClickHandler}></button>
      </span>
      <span>
        <img src="/src/assets/img/icons/dots.svg" alt="dots" />
      </span>
    </li>
  )
}
